import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export function SuperadminRoute() {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!user?.perfis?.includes('SUPERADMIN')) return <Navigate to="/painel" replace />;

  return <Outlet />;
}
